export const recepcionista = {
  nome: 'Recepcionista',
  id_perfil: 5,
  dashboard: [
    {
      link: '',
      titulo: 'Pódio e equipes por classificação',
      icone: false,
      imagem: '',
      svg: '',
      key: 'modal_ranking_indicadores_aps',
      type: 'modal',
    },
    {
      link: '/vinculo-acompanhamento',
      titulo: 'Vínculo e Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'VinculoAcompanhamento',
      key: 'vinculo_acompanhamento',
    },
    {
      link: '/indicadores-aps',
      titulo: 'Indicadores APS',
      icone: false,
      imagem: '',
      svg: 'IndicadoresAps',
      key: 'indicadores_aps',
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/saude-bucal',
      titulo: 'Saúde Bucal',
      icone: false,
      imagem: '',
      svg: 'IndicadoresEsb',
      key: 'saude_bucal',
    },
    {
      link: '/cidadaos-cns-invalidos',
      titulo: 'Cidadãos CNS inválido',
      icone: 'icofont-close-circled',
      key: 'cns_invalido',
    },
    {
      link: '/cidadaos-desatualizados',
      titulo: 'Cidadãos desatualizados',
      icone: 'icofont-loop',
      key: 'cidadaos_desatualizados',
    },
    {
      link: '/aedes-aegypti/acs',
      titulo: 'Aedes aegypti',
      icone: false,
      imagem: '',
      svg: 'AedesAegypti',
      key: 'aedes_aegypti',
    },
    // {
    //   link: '/pos-covid-19/acs',
    //   titulo: 'Pós Covid-19',
    //   icone: false,
    //   imagem: '',
    //   svg: 'PosCovid19',
    //   key: 'pos_covid_19',
    // },
    {
      link: '/oficinas-treinamentos',
      titulo: 'Oficinas Reuniões Treinamentos',
      icone: 'icofont-presentation',
      key: 'oficinas_treinamentos',
      featured: true,
    },
    {
      link: '/upa',
      titulo: 'UPA',
      icone: 'icofont-hospital',
      key: 'upa',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/cidadao/painel',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
      // openNewTab: true,
      // callback: function (ctx, navigate) {
      //   const parceiro = ctx.$store.state?.infoMunicipio?.parceiro
      //   if (parceiro == null) {
      //     navigate(this.link, this.openNewTab)
      //   } else {
      //     ctx.$toast.error('Não disponível.', '', { position: 'topRight' })
      //   }
      // },
    },
    {
      link: '/busca-ativa-cadastro',
      titulo: 'Busca Ativa Cadastro',
      icone: 'icofont-people',
      key: 'cidadaos_sem_equipe',
    },
    {
      link: '/cidadaos-duplicados',
      titulo: 'Cidadãos duplicados',
      icone: 'icofont-copy-invert',
      key: 'cidadaos_duplicados',
    },
    {
      link: '/calculadora-de-pessoas',
      titulo: 'Calculadora de pessoas',
      icone: 'icofont-ui-calculator',
      key: 'calculadora_de_pessoas',
    },
    {
      link: '/obitos/profissional',
      titulo: 'Óbitos',
      icone: 'icofont-list',
      key: 'obitos',
    },
    {
      link: '/mudanca_territorio/profissional',
      titulo: 'Mudança de Território',
      icone: 'icofont-list',
      key: 'mudanca_territorio',
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [
    {
      link: '/esf-eap',
      titulo: 'eSF / eAP',
      icone: false,
      imagem: '',
      svg: 'eSFeAP',
      key: 'esf_eap',
    },
    {
      link: '/emulti',
      titulo: 'eMulti',
      icone: false,
      imagem: '',
      svg: 'eMulti',
      key: 'emulti',
    },
    {
      link: '/indicadores-esb',
      titulo: 'eSB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'indicadores_esb',
    },
    {
      link: '/indicadores-aps/resultado-municipal',
      titulo: 'Resultado Municipal',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'resultado_municipal_indicadores_aps',
    },
    // {
    //   link: '/resultado-indicadores',
    //   titulo: 'Resultado Indicadores',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ResultadoIndicadores',
    //   key: 'resultado_indicadores',
    // },
    // {
    //   link: '/desempenho-por-equipe',
    //   titulo: 'Desempenho por Equipe',
    //   icone: false,
    //   imagem: '',
    //   svg: 'DesempenhoPorEquipe',
    //   key: 'desempenho_por_equipe',
    // },
  ],
  pre_natal: [
    // {
    //   link: '/consultas-pre-natal/profissional',
    //   titulo: 'Consultas pré-natal',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ConsultasPreNatal',
    //   key: 'consultas_pre_natal',
    // },
    // {
    //   link: '/consultas-odontologicas/profissional',
    //   titulo: 'Consultas odontológicas',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ConsultasOdontologicas',
    //   key: 'consultas_odontologicas',
    // },
    // {
    //   link: '/exames-hiv-sifilis/profissional',
    //   titulo: 'Exames HIV e Sífilis',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ExamesHivSifilis',
    //   key: 'hiv_sifilis',
    // },
    // {
    //   link: '/tres-indicadores-pre-natal/equipe/acs',
    //   titulo: 'Os 3 Indicadores Pré-natal',
    //   icone: false,
    //   imagem: '',
    //   svg: 'TresIndicadoresPreNatal',
    //   key: 'tres_indicadores_pre_natal',
    // },
  ],
  doencas_cronicas: [
    // {
    //   link: '/hemoglobina-glicada/profissional',
    //   titulo: 'Atendimento diabetes',
    //   icone: false,
    //   imagem: '',
    //   svg: 'AtendimentosDiabetes',
    //   key: 'atendimento_diabetes',
    // },
    // {
    //   link: '/atendimento-hipertensao/profissional',
    //   titulo: 'Atendimento Hipertensão',
    //   icone: false,
    //   imagem: '',
    //   svg: 'AtendimentoHipertensao',
    //   key: 'atendimento_hipertensao',
    // },
    // {
    //   link: '/hiper-dia/profissional',
    //   titulo: 'Atendimento HiperDia',
    //   icone: false,
    //   imagem: '',
    //   svg: 'HiperDia',
    //   key: 'atendimento_hiper_dia',
    // },
  ],
  desempenho_por_equipe: [
    // {
    //   link: '/desempenho-por-equipe/indicador',
    //   titulo: 'Desempenho por Indicador',
    //   icone: 'icofont-brand-designbump',
    //   key: 'desempenho_por_indicador',
    // },
    // {
    //   link: '/desempenho-por-equipe/geral',
    //   titulo: 'Desempenho Geral',
    //   icone: 'icofont-brand-designbump',
    //   key: 'desempenho_geral',
    // },
  ],
  saude_crianca: [],
  producao: [],
  vinculo_acompanhamento: [
    {
      link: '/diagnostico-situacional',
      titulo: 'Resultado Municipal',
      icone: false,
      imagem: '',
      svg: 'DesempenhoPorEquipe',
      key: 'diagnostico_situacional',
    },
    {
      link: '/cadastros-individuais/profissional',
      titulo: 'Cadastros cidadãos',
      icone: false,
      imagem: '',
      svg: 'CadastrosCidadaos',
      key: 'cadastros_cidadaos',
    },
    {
      link: '/acompanhamento',
      titulo: 'Acompanhamento',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'acompanhamento',
    },
    {
      link: '/avaliacao-atendimentos',
      titulo: 'Avaliação do atendimento',
      icone: 'icofont-heart-eyes',
      key: 'avaliacao_atendimentos',
    },
    {
      link: '/agenda-por-profissional/profissional',
      titulo: 'Agendamentos',
      icone: 'icofont-ui-calendar',
      key: 'agenda_por_profissional',
    },
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'vinculo_acompanhamento_atendimentos_pessoa',
    },
  ],
  bpa_e_ras: [],
  saude_bucal: [
    {
      link: '/indicadores-esb',
      titulo: 'Indicadores eSB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'indicadores_esb',
    },
    {
      link: '/lrpd',
      titulo: 'LRPD',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal_lrpd',
    },
    {
      link: '/sesb',
      titulo: 'SESB',
      icone: false,
      imagem: '',
      svg: 'SaudeBucal',
      key: 'saude_bucal_sesb',
    },
  ],
  indicadores_esb: [
    {
      link: '/primeira-consulta-programada',
      titulo: 'Primeira consulta',
      icone: false,
      imagem: '',
      svg: 'PrimeiraConsultaProgramada',
      key: 'primeira_consulta_programada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-concluidos',
      titulo: 'Tratamentos concluídos',
      icone: false,
      imagem: '',
      svg: 'TratamentosConcluidos',
      key: 'tratamentos_concluidos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/exodontias',
      titulo: 'Exodontias',
      icone: false,
      imagem: '',
      svg: 'Exodontias',
      key: 'exodontias',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/escovacao-supervisionada',
      titulo: 'Escovação supervisionada',
      icone: false,
      imagem: '',
      svg: 'EscovacaoSupervisionada',
      key: 'escovacao_supervisionada',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/procedimentos-odonto-preventivos',
      titulo: 'Procedimentos preventivos',
      icone: false,
      imagem: '',
      svg: 'Prevencao',
      key: 'proporcao_procedimentos_preventivos',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/tratamentos-restauradores-atramautico',
      titulo: 'Tratamento Atraumático',
      icone: false,
      imagem: '',
      svg: 'TratamentosRestauradoresArt',
      key: 'tratamentos_restauradores_art',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
    {
      link: '/saude-bucal-gestantes',
      titulo: 'Gestantes',
      icone: false,
      imagem: '',
      svg: 'ConsultasPreNatal',
      key: 'saude_bucal_gestantes',
      ribbon: {
        enabled: true,
        text: 'eSB',
      },
    },
  ],
  esf_eap: [
    // {
    //   link: '/busca-ativa/equipe/acs',
    //   titulo: 'Busca Ativa',
    //   icone: 'icofont-search-user',
    //   key: 'busca_ativa',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/mais-acesso-aps',
      titulo: 'Mais acesso',
      icone: false,
      imagem: '',
      svg: 'MaisAcessoAps',
      key: 'mais_acesso_aps',
    },
    // {
    //   link: '/indicador-citologico/profissional',
    //   titulo: 'Exames Citopatológico',
    //   icone: 'icofont-stretcher',
    //   key: 'citopatologico',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    // {
    //   link: '/indicador-imunizacao/profissional',
    //   titulo: 'Desenvolvimento infantil',
    //   icone: 'icofont-baby',
    //   key: 'vacinas_polio_penta',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/desenvolvimento-infantil',
      titulo: 'Desenvolvimento infantil',
      icone: false,
      imagem: '',
      svg: 'DesenvolvimentoInfantil',
      key: 'desenvolvimento_infantil',
    },
    {
      link: '/gestantes-puerperas',
      titulo: 'Gestantes puérperas',
      icone: false,
      imagem: '',
      svg: 'GestantesPuerperas',
      key: 'gestantes_puerperas',
    },
    // {
    //   link: '/pre-natal',
    //   titulo: 'Gestantes e Puérperas',
    //   icone: false,
    //   imagem: require('@/assets/images/pregnant.png'),
    //   key: 'pre_natal',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    // {
    //   link: '/doencas-cronicas',
    //   titulo: 'Doenças crônicas',
    //   icone: 'icofont-drug',
    //   key: 'doencas_cronicas',
    //   ribbon: {
    //     enabled: true,
    //     text: 'ESF',
    //   },
    // },
    {
      link: '/pessoa-diabetes',
      titulo: 'Pessoa diabética',
      icone: false,
      imagem: '',
      svg: 'PessoaDiabetes',
      key: 'pessoa_diabetes',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pessoa-hipertensao',
      titulo: 'Pessoa hipertensa',
      icone: false,
      imagem: '',
      svg: 'PessoaHipertensao',
      key: 'pessoa_hipertensao',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/pessoa-idosa',
      titulo: 'Pessoa idosa',
      icone: false,
      imagem: '',
      svg: 'PessoaIdosa',
      key: 'pessoa_idosa',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
    {
      link: '/saude-da-mulher',
      titulo: 'Saúde mulher',
      icone: false,
      imagem: '',
      svg: 'SaudeDaMulher',
      key: 'saude_da_mulher',
      ribbon: {
        enabled: true,
        text: 'ESF',
      },
    },
  ],
  emulti: [
    {
      link: '/media-atendimentos-por-pessoa',
      titulo: 'Pessoas atendidas',
      icone: false,
      imagem: '',
      svg: 'PessoasAtendidas',
      key: 'media_atendimentos_por_pessoa_emulti',
    },
    {
      link: '/acoes-interprofissionais',
      titulo: 'Ações interprofissionais',
      icone: false,
      imagem: '',
      svg: 'AcoesInterprofissionais',
      key: 'acoes_interprofissionais',
      ribbon: {
        enabled: true,
        text: 'eMulti',
      },
    },
  ],
  oficinas_treinamentos: [
    {
      link: '/oficinas-treinamentos-participante',
      titulo: 'Participante',
      icone: 'icofont-user',
      key: 'oficinas_treinamentos_participante',
    },
    {
      link: '/oficinas-treinamentos-certificados',
      titulo: 'Meus Certificados',
      icone: 'icofont-certificate',
      key: 'oficinas_treinamentos_certificados',
    },
  ],
  upa: [
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'upa_atendimentos_pessoa',
    },
  ],
}
